module.exports = __webpack_public_path__ + "img/Impact identification-Impact interaction.44e91ac9.svg";